import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useNavigation } from "react-router";
import { useTranslation } from "@/i18n";

/** Show a thin indeterminate progress bar at the top of the viewport while
 *  React Router is loading data for a new route or running an action. We
 *  delay rendering by `SHOW_AFTER_MS` so fast cached navigations don't flash
 *  the bar. */
const SHOW_AFTER_MS = 150;

export const RouteProgressBar = observer(function RouteProgressBar() {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const pending = navigation.state !== "idle";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!pending) {
      setVisible(false);
      return;
    }
    const timer = window.setTimeout(() => setVisible(true), SHOW_AFTER_MS);
    return () => window.clearTimeout(timer);
  }, [pending]);

  if (!visible) return null;

  return (
    <div
      role="progressbar"
      aria-label={t("common.loading_aria")}
      aria-busy="true"
      className="pointer-events-none fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden bg-transparent"
    >
      <div className="h-full w-1/3 animate-route-progress bg-primary" />
    </div>
  );
});
